<template>
    <!-- Footer -->
    <footer class="border-t border-gray-200">
        <div class="mx-auto max-w-7xl overflow-hidden px-4 sm:px-6 lg:px-8 py-5 sm:py-20">
            <div class="flex flex-col sm:flex-row gap-5 sm:gap-12 justify-center items-center mb-5 sm:mb-8">
                <div>
                    <img
                        class="w-56"
                        src="/Logo_Sozialministerium_2026.svg"
                        alt="Logo Sozialministerium">
                </div>

                <p class="w-56 text-xs text-justify text-gray-500">
                    Finanziert durch das Ministerium für Soziales, Arbeit und Gesundheit aus Landesmitteln, die der Landtag Baden-Württemberg beschlossen hat.
                </p>
            </div>
            <div class="text-center text-xs leading-5 text-gray-500 flex justify-center gap-4">
                <span
                    class="truncate"
                    title="&copy; {{ dayjs().year() }} oaseBW, Evangelisches Jugendwerk in Württemberg.">
                    &copy; {{ dayjs().year() }} oaseBW, Evangelisches Jugendwerk in Württemberg.
                </span>
                <span>|</span>
                <div
                    v-for="(item, index) in cmsFooterNavItems"
                    :key="item.title">
                    <NuxtLink
                        class="me-2"
                        :to="'/' + item.path">
                        {{ item.title }}
                    </NuxtLink>
                    <span v-if="index < cmsFooterNavItems.length - 1">|</span>
                </div>
                <!--            <NuxtLink-->
                <!--                to="impressum"-->
                <!--                class="hover:text-gray-900 hover:dark:text-gray-50">-->
                <!--                Impressum-->
                <!--            </NuxtLink>-->
                <!--            <span>|</span>-->
                <!--            <NuxtLink-->
                <!--                to="privacy"-->
                <!--                class="hover:text-gray-900 hover:dark:text-gray-50">-->
                <!--                Datenschutz-->
                <!--            </NuxtLink>-->
            </div>
        </div>
    </footer>
</template>

<script setup>
import {useCmsNavItemsStore} from "@/store/cmsNavItems"

const dayjs = useDayjs()

const cmsNavItemsStore = useCmsNavItemsStore()

const cmsFooterNavItems = computed(() => {
    return cmsNavItemsStore.cmsNavItems?.filter((item) => item.showInFooterMenu).map((item) => {
        return {
            title: item.title,
            path: item.slug,
        }
    })
})
</script>
